<div class="hot-table sku-config-table hot-custom-check-box">
  <hot-table [hotId]="hotTableId" [settings]="hotTableSettings" [licenseKey]="handsontableLicenseKey"></hot-table>
</div>

